/**
 * Label for a user: first+last when present, else API `name` (e.g. comments),
 * else username. Skips API `name` when it is the literal "Unknown User" so
 * `userName` can be shown instead when the server sends both.
 *
 * @param {object|null|undefined} user
 * @returns {string}
 */
export function displayUserName(user) {
    if (!user) return "Unknown User";

    const first = user.firstName ?? user.first_name ?? "";
    const last = user.lastName ?? user.last_name ?? "";
    const fromFirstLast = `${first} ${last}`.trim();
    if (fromFirstLast) return fromFirstLast;

    const apiName = (user.name ?? "").trim();
    if (apiName && apiName !== "Unknown User") return apiName;

    const handle = (user.userName ?? user.user_name ?? "").trim();
    if (handle) return handle;

    if (apiName) return apiName;

    return "Unknown User";
}
